import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import App from './App.jsx';
import * as Sentry from '@sentry/react';
import { TRACKING_DISABLED } from './Utils/environment';

/*
 * Third-party integrations.
 *
 * None of them are initialised when TRACKING_DISABLED is true, which covers local development and
 * Cypress runs. On test and production the predicate is false and everything below runs exactly as
 * it did before. Until now only Tag Manager honoured the Cypress flag, so test runs were reaching
 * the production Sentry project and GA4 property.
 */
if (!TRACKING_DISABLED) {
  Sentry.init({
    dsn: 'https://7b5bd5caf8ef55a1d57bb2178cd30295@o4508518044467200.ingest.us.sentry.io/4508740155867136',
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'https://allybot-test.vidaselect.com/api/'],
      }),
      new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 100%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  ReactGA.initialize('G-EQ1NSFGFM6');

  TagManager.initialize({
    gtmId: 'GTM-M4ZRLP9',
    dataLayer: {
      event: 'allybot2_loaded',
    },
  });
} else {
  // react-gtm-module falls back to injecting a script tag when window.dataLayer is missing.
  // Seeding it keeps every TagManager.dataLayer() call in the funnel a plain array push, so the
  // events stay readable in the console instead of being lost.
  window.dataLayer = window.dataLayer || [];
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
